export default {
    common: {
        // UI Labels
        login: "Login",
        password: "Password",
        passwordConfirm: "Confirm Password",
        register: "Register",
        noAccount: "Don't have an account?",
        hadAccount: "Already have an account?",
        registerNow: "Register Now",
        back: "Back",
        logout: "Logout",

        // Account Messages
        loginSuccess: "Login Success",
        loginSuccessDesc: "Dear, Welcome back!",
        passwordPlaceholder: "Please enter your password",
        password2Placeholder: "Please enter your password again",
        passwordError: "Length between 6 and 30 characters",
        passwordError2: "The two passwords do not match",
        read: "I have read and agree to",
        terms: "Privacy Policy and Terms of Service",
        serviceTerms: "Terms of Service",
        privacyPolicy: "Privacy Policy",
        jump: "Jumping to",
        backToHome: "Back to Home",
        bindSuccess: "Bind Success",
        accountBind: "Account has been bound",
        editBind: "Edit",

        // Route Name
        dashboard: "Dashboard",
        usernameLogin: "Login - Username",
        usernameRegister: "Register - Username",
        emailLogin: "Login - Email",
        emailRegister: "Register - Email",
        emailResetPassword: "Reset Password - Email",
    },
    email: {
        // UI Labels
        address: "Email",
        nickname: "Nickname",
        lang: "Language",
        code: "Code",
        invite_code: "Invite Code",
        next: "Next",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",

        // UI Placeholders
        forgetPassword: "Forgot Password",
        emailRegistered: "Email has been registered",

        // UI Errors
        addressPlaceholder: "Please enter your email address",
        addressError: "Please enter a valid email address",
        nicknamePlaceholder: "Please enter your nickname",
        nicknameError: "Please enter a valid nickname",

        // UI Messages
        // Register
        send: "Send Code",
        sendSuccess: "Send Success",
        registerSuccess: "Register Success",
        registerSuccessDesc: "Congratulations, your account is now active!",

        waitVerify: "Wait for verification",
        successDesc:
            "A verification email has been sent to your email address {email}. Click the activation link to complete your registration successfully! The email is valid for 24 hours.",

        registerFailed: "Registration failed",
        registerFailedDesc: "Registration failed, please try again later",

        // Login
        loginFailed: "Login failed, please check the email and password",

        // Reset
        resetEmailPlaceholder: "yourname@example.com",
        illegalRequest: "Illegal request",
        resend: "Resend",
        resetSuccess: "Reset Success",
        resetSuccessDesc: "Your password has been reset successfully",
        findPassword: "We will send an email containing the reset verification code to your mailbox.",
        resetPassword: "Reset Password",
        sendResetSuccess: "Send Success",
    },
    username: {
        name: "Username",
        namePlaceholder: "Please enter your username",
        nameError: "Length between 3 and 30 characters",
        loginFailed: "Login failed, please check the username and password",
        nameExist: "Username already exists",
        nameValidate: "The username must start with a letter and be between 3 and 20 characters long",

        registerSuccess: "Register Success",
        registerSuccessDesc: "Congratulations, your account is now active!",
        resetPassword: "Recover Username Account",
        resetPasswordDesc: "Recover a username account password through your bound email or phone number.",
        resetByEmail: "Recover by Email",
        resetByPhone: "Recover by Phone",
    },
    phone: {
        number: "Phone number",
        code: "Code",

        phoneRegistered: "PhoneNumber has been registered",

        // UI Errors
        numberPlaceholder: "Please enter your phone number",
        numberError: "Please enter a valid phone number",
        codePlaceholder: "Please enter the verification code",
        codeError: "Please enter the correct verification code",
        passwordPlaceholder: "Please enter your password",
        passwordError: "Length between 6 and 30 characters",
        smsCodePlaceholder: "Please enter the SMS verification code",
        smsCodeError: "Please enter the correct SMS verification code",

        // UI Messages
        send: "Send Code",
        sendSuccess: "Send Success",
        registerSuccess: "Register Success",
        registerSuccessDesc: "Congratulations, your account is now active!",
        registerFailed: "Registration failed",
        registerFailedDesc: "Registration failed, please try again later",

        // Login
        loginFailedWithPwd: "Login failed, please check the phone number and password",

        // Reset
        resetPassword: "Reset Password",
        resetSuccess: "Reset Success",
        resetSuccessDesc: "Your password has been reset successfully",
    },
    union: {
        wechat: "Wechat",

        // 通用回调
        unknownTitle: "Something went wrong",
        unknownDesc: "Unknown Error. Please try again later.",

        // 注册回调
        login: "Login Now",
        registerSuccess: "Register Success",
        registerSuccessDesc: "Congratulations, your account is now active!",
        registerFailed: "Registration failed",
        registerFailedDesc: "Account already exists, please login directly",

        // 登录回调
        register: "Register Now",
        loginSuccess: "Login Success",
        loginSuccessDesc: "Dear, Welcome back!",
        loginFailed: "Login Failed",
        loginFailedDesc: "Account does not exist. Please register first.",

        // 绑定
        bind: "Bind Now",
        bindFailed: "Bind Failed",
        bindFailedDesc: "This account has been bound by other users, please do not bind it again",

        // 解绑
        unbind: "Unbind",
        unbindTip: "Confirm to unbind this associated account? You will no longer be able to log in via {type}",
    },

    login_v2: {
        welcome: "Welcome",

        wechatLogin: "Scan",
        accountLogin: "Email",
        phoneLogin: "Phone",
        emailRegister: "Email",
        phoneRegister: "Phone",

        fsf: "FSF Options Lab",
        other: "Other Login Methods",
    },
};
